import { NextPage } from "next";
import { useSelectSlice } from "@common/redux/selectors/useSelectSlice";
import { recommendationSlice } from "@common/redux/slices/recommendation.slice";
import { Layout } from "@kursk/components/Layout/Layout";
import { HeaderBlock } from "@kursk/components/ui/HeaderBlock/HeaderBlock";
import { ContentBlock } from "@kursk/components/ui/ContentBlock/ContentBlock";
import styles from "./SingleHotel.module.scss";
import { SocialLinks } from "@kursk/components/ui/SocialLinks/SocialLinks";
import { Tags } from "@kursk/components/ui/Tags/Tags";
import { RecommendationsBlock } from "@kursk/components/ui/RecommendationsBlock/RecommendationsBlock";
import { Socials } from "@kursk/components/pages/Home/Socials/Socials";
import { ContactsBlock } from "@kursk/components/ui/ContactsBlock/ContactsBlock";
import React from "react";
import { hotelsListSlice } from "@common/redux/slices/hotels.slice";
import { Facilities } from "@kursk/components/pages/SingleHotel/Facilities/Facilities";
import moment from "moment";
import { SeoMetaTitles } from "@kursk/components/seo/SeoMetaTitles";
import { getAddress } from "@kursk/utils/getAddress";
import { LdJson } from "@kursk/components/seo/LdJson";
import { FeedbacksBlock } from "@kursk/components/ui/FeedbacksBlock/FeedbacksBlock";

export const SingleHotel: NextPage = () => {
  const { hotel } = useSelectSlice(hotelsListSlice);
  const timeStart = moment(hotel?.start).format("HH:mm");
  const timeEnd = moment(hotel?.end).format("HH:mm");
  const { forHotelsPlacesNear, forHotelsRestaurantsNear, forHotelsHotels } = useSelectSlice(recommendationSlice);
  if (!hotel) {
    return <></>;
  }
  return (
    <Layout key={`hotel_${hotel._id}`}>
      <LdJson
        entity={hotel}
        type={'hotels'}
      />
      <SeoMetaTitles page="singleHotel" entity={{
        name: hotel.name,
        seo: hotel.seo,
        image: hotel.image,
        address: getAddress(hotel.address),
      }} showOgImage={true}/>
      <section className={styles.hotel_header}>
        <HeaderBlock
          entityType={'hotels'}
          entity={hotel}
          goBack={'/hotels'}
          goBackTitle={'вернуться к списку гостиниц'}/>
      </section>
      <section className={styles.entity_share}>
        <SocialLinks/>
      </section>
      <section className={styles.entity_content}>
        <ContentBlock content={hotel.content} source={hotel?.source} />
      </section>
      <section className={styles.hotel_facilities}>
        <Facilities facilities={hotel.facilities}/>
      </section>
      {(hotel.start || hotel.end) && (
        <section className={styles.hotel_checkIn}>
          <div className={styles.hotel_checkIn__title}>
            заселение и выезд
          </div>
          {hotel.start && <div className={styles.hotel_checkIn__checkIn}>Заселение после {timeStart}</div>}
          {hotel.end && <div className={styles.hotel_checkIn__checkOut}>Выезд до {timeEnd}</div>}
        </section>
      )}
      <section className={styles.entity_contacs}>
        <ContactsBlock entity={hotel}/>
      </section>
      <section className={styles.entity_tags}>
        <Tags link={'/hotels'} className={styles.tags} tags={hotel?.tags}/>
      </section>
      <section className={styles.entity_feedbacks}>
        <FeedbacksBlock entity={hotel} entityType={'hotels'}/>
      </section>
      <section className={styles.entity_recommendations}>
        <RecommendationsBlock
          entityType="places"
          data={forHotelsPlacesNear}
          title={'рядом находится'}
          goTo={'/places'}
          goToTitle={'все места'}/>
      </section>
      <section className={styles.entity_recommendations}>
        <RecommendationsBlock
          entityType="restaurants"
          data={forHotelsRestaurantsNear}
          title={'рестораны рядом'}
          goTo={'/restaurants'}
          goToTitle={'все рестораны'}/>
      </section>
      <section className={styles.entity_recommendations}>
        {
          forHotelsHotels.map(hotel => {
            return <LdJson
              key={hotel._id}
              entity={hotel}
              type={'hotels'}
            />
          })
        }
        <RecommendationsBlock
          entityType="hotels"
          data={forHotelsHotels}
          title={'также рекомендуем'}
          goTo={'/hotels'}
          goToTitle={'все гостиницы'}/>
      </section>
      <section className={styles.entity_social}>
        <Socials/>
      </section>
    </Layout>
  )
}
